"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineAllWatchers = combineAllWatchers;
const effects_1 = require("redux-saga/effects");
function combineAllWatchers(watchers) {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    return function* combinedWatcherSaga() {
        const activeWatchers = watchers.map((watcher) => watcher());
        return yield (0, effects_1.all)(activeWatchers);
    };
}
//# sourceMappingURL=combineAllWatchers.js.map